module.exports = {
  assetPrefix: `/code-campaign`,
  trailingSlash: `ignore`,
  siteMetadata: {
    baseUrl: `https://www.crunchyroll.com`,
    url: `https://www.crunchyroll.com/code-campaign`,
    title: `Crunchyroll Member Perks | Code Campaigns`,
    description: `Find limited-time Crunchyroll member perks and partner code campaigns. Sign in to check eligibility and claim available codes.`,
    ogTitle: `Crunchyroll Member Perks | Code Campaigns`,
    ogDescription: `Explore limited-time Crunchyroll member perks and partner code campaigns.`,
    banner: {
      url: `https://www.crunchyroll.com/code-campaign/default-banner.jpg`,
      width: `1080`,
      height: `565`,
    },
  },
  plugins: [
    {
      resolve: `gatsby-source-filesystem`,
      options: {
        name: `images`,
        path: `${__dirname}/src/images`,
      },
    },
    `gatsby-plugin-emotion`,
    `gatsby-plugin-react-helmet`,
    `gatsby-transformer-sharp`,
    {
      resolve: `gatsby-plugin-sharp`,
      options: {
        defaults: {
          formats: [`auto`, `webp`],
          quality: 80,
        },
      },
    },
    `gatsby-plugin-image`,
  ],
}
